import React, { useContext, useEffect, useMemo, useState } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import { Journey } from "@/types/*";
import { CommonDataContext } from "../../../../context/CommonDataContext";
import { extractResource } from "../../../../helper/extractResource";
import CustomSwitch from "../../../CustomSwitch/CustomSwitch";
import { CheckinJourneySelectionCardGroupV2 } from "../CheckinJourneySelectionCardGroupV2/CheckinJourneySelectionCardGroupV2";
import { setGroupSelectedJourneysCard } from "@/store/slices/groupBooking";

const label = { inputProps: { "aria-label": "Switch demo" } };

interface JourneyCardV2Props {
  journeysInfo: Journey[];
  props?: Record<string, unknown>;
}

function JourneyCardV2({ journeysInfo, ...props }: JourneyCardV2Props) {
  const dispatch = useDispatch();
  const { resources } = useContext(CommonDataContext);
  const [journeysCard, setJourneysCard] = useState(journeysInfo);

  const toggle = (e?: React.ChangeEvent<HTMLInputElement>, journeyKey?: string) => {
    const { name, checked } = e.target;

    const selectedJourneys = journeysCard.map((journeyCard) => {
      if (name === "allSelect") {
        // Check if the journey's departure is in the future
        return {
          ...journeyCard,
          isChecked: moment(journeyCard.designator.departure) > moment() ? checked : false
        };
      } else if (name === "journeyCard0" || name === "journeyCard1") {
        // Update the specific journey based on journeyKey
        return journeyCard.journeyKey === journeyKey ? { ...journeyCard, isChecked: checked } : journeyCard;
      }
      return journeyCard; // Return the journeyCard unchanged if no conditions match
    });

    setJourneysCard(selectedJourneys);
    const selectedJourneysOnly = selectedJourneys.filter((journey) => journey.isChecked);

    dispatch(setGroupSelectedJourneysCard({ groupSelectedJourneysCard: selectedJourneysOnly}))
  };

  // Memoize the journeysInfo to avoid unnecessary re-renders
  const memoizedJourneysInfo = useMemo(() => {
    return journeysInfo?.length > 0 ? journeysInfo : [];
  }, [journeysInfo]);

  useEffect(() => {
    setJourneysCard(memoizedJourneysInfo);
  }, [memoizedJourneysInfo]);

  return (
    <>
      {journeysCard?.length > 1 && (
        <div id="selectAllSection" className="flex justify-between items-center ml-1">
          <p className="font-medium text-typography-primary">{extractResource(resources, "selectAll")}</p>
          <CustomSwitch
            className={"cssStyle.customSwitch"}
            onChange={toggle}
            checked={journeysCard.filter((journeyCard) => journeyCard?.isChecked !== true).length < 1}
            disabled={journeysCard.filter((journeyCard) => journeyCard?.restrictions == null)?.length < 2}
            name="allSelect"
            {...label}
            color="primary"
          />
        </div>
      )}

      {journeysCard?.map((journeyCard: any, id: number) => {
        return (
          <div aria-label="flight-schedule" key={id}>
            <div
              key={id}
              className="flex flex-row justify-between items-center my-2 px-2 h-auto bg-white rounded-md"
              style={{ boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)" }}
            >
              <CheckinJourneySelectionCardGroupV2
                journeyCard={journeyCard}
                toggle={toggle}
                id={id}
              />
            </div>
          </div>
        );
      })}
    </>
  );
}
export default JourneyCardV2;